import BaseCommand from "@/models/api/commands/BaseCommand";

export class AddFilesCommand extends BaseCommand {
  CommandName = "AddFiles";
  Command: { FileIds: Array<number>; Type: number };
  constructor(sessionId: string, operationId: string, fileIds: Array<number>, type: number) {
    super(sessionId, operationId);
    this.Command = { FileIds: fileIds, Type: type };
  }
}
